"use client";

import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import React from "react";
import ProgramForm from "./ProgramForm";
import ProgramTableGrid from "./ProgramTable";

export default function Programs() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Paper
        sx={{
          mb: 5,
          ml: "auto",
          display: "flex",
          flexWrap: "wrap",
          gap: 3,
          alignItems: "end",
          justifyContent: "start",
        }}
        elevation={6}
      >
        <p style={{ fontSize: "1.25rem", marginLeft: "2rem", marginBottom: "2rem" }}>
          Programs
        </p>
        <Box
          sx={{
            mb: 5,
            ml: "auto",
            display: "flex",
            flexWrap: "wrap",
            gap: 6,
            alignItems: "end",
            justifyContent: "start",
          }}
        >
          <Button
            id="create-program-button"
            variant="contained"
            onClick={handleClickOpen}
            sx={{ ml: "auto", mr: 5, mt: 4 }}
            startIcon={<AddIcon />}
          >
            Create New Program
          </Button>
        </Box>
      </Paper>

      <ProgramTableGrid />
      <ProgramForm open={open} handleClose={handleClose} isNewProgram={true} />
    </>
  );
}
